export default {
  SettingsBtnInvoiceTemplateNumberDelete: 'SettingsBtnInvoiceTemplateNumberDelete',
  SettingsBtnInvoiceTemplateNumberChangeNumber: 'SettingsBtnInvoiceTemplateNumberChangeNumber',

  SettingsPagePriceListsList: 'SettingsPagePriceListsList',
  SettingsPagePriceListsEdit: 'SettingsPagePriceListsEdit',
  SettingsPageBasePriceListsEdit: 'SettingsPageBasePriceListsEdit',
  SettingsPageBasePriceListsDelete: 'SettingsPageBasePriceListsDelete',
  SettingsPageTemplatesEvidenceDescriptionsList: 'SettingsPageTemplatesEvidenceDescriptionsList',
  SettingsPageAdminPanel: 'SettingsPageAdminPanel',
  SettingsPageSubscriptionPanel: 'SettingsPageSubscriptionPanel',
  SettingsPageTemplatesInvoiceDescriptionsList: 'SettingsPageTemplatesInvoiceDescriptionsList',
  SettingsPageTemplatesInvoiceDescriptionsEdit: 'SettingsPageTemplatesInvoiceDescriptionsEdit',

  SettingsPageInvoiceTemplateNumberList: 'SettingsPageInvoiceTemplateNumberList',
  SettingsPageInvoiceTemplateNumberAdd: 'SettingsPageInvoiceTemplateNumberAdd',
  SettingsPageInvoiceTemplateNumberChangeNumber: 'SettingsPageInvoiceTemplateNumberChangeNumber',

  SettingsPageTemplatesKhTemplatesList: 'SettingsPageTemplatesKhTemplatesList',
  SettingsPageTemplatesKhTemplatesEdit: 'SettingsPageTemplatesKhTemplatesEdit',

  SettingsPageSubscriptionOrdersList: 'SettingsPageSubscriptionOrdersList',
  SettingsPageSystemBalancesList: 'SettingsPageSystemBalancesList',
  SettingsPageSystemRolesList: 'SettingsPageSystemRolesList',

  SettingsPageSystemTaskList: 'SettingsPageSystemTaskList',
  SettingsPageSystemTaskEdit: 'SettingsPageSystemTaskEdit',

  UserInfoDialogAccess: 'UserInfoDialogAccess',
};
